import { Image } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { ImageWithDimensions } from '../types';

export const EMPTY_IMAGE_SIZE = 200;

export const newImage: Image = { name: '', url: '' };

export const newImageWithDimensions = (image?: Image | ImageWithDimensions): ImageWithDimensions => {
  if (image === undefined) {
    return {
      name: '',
      url: '',
      crop: undefined,
      width: EMPTY_IMAGE_SIZE,
      height: EMPTY_IMAGE_SIZE,
    };
  }

  if (isImageWithDimensions(image)) return { ...image };

  return addDimensions(image);
};

export const createImagesWithDimensions = (imageCount: number, images: Image[] | ImageWithDimensions[] = []) =>
  Array.from({ length: imageCount }).map((_, index) => newImageWithDimensions(images[index]));

export const addDimensions = (image: Image, width = 0, height = 0): ImageWithDimensions => ({
  ...image,
  width,
  height,
});

export const removeDimensions = (imageWithDimensions: ImageWithDimensions): Image => {
  const { width, height, ...image } = imageWithDimensions;
  return image;
};

const isImageWithDimensions = (image: Image | ImageWithDimensions): image is ImageWithDimensions =>
  'width' in image && 'height' in image;
